// extracted by mini-css-extract-plugin
module.exports = {"container":"container__5pxkY","iconWrapper":"iconWrapper__3hdJL","icon":"icon__1nodc","heading":"heading__20U9f","content":"content__8rwwt","buttonGroup":"buttonGroup__1aQou"};